import { Form, Formik, Field } from "formik";
import React, { FC, useEffect, useRef, useState } from "react";
import UIModal from "../../../shared/components/UIModal";
import ToggleSwitch from "../../../shared/components/ToggleSwitch";
import UploadLogo from "../../../shared/components/UploadLogo";
import InputField from "../../../shared/components/InputField";
import "./instituteForm.scss";
import { serialize } from "serializr";
import {
  Institute,
  Institutes,
} from "../../../models/InstituteModel/institutes.model";
import { convertJSONToFormData } from "../../../shared/utils/converJsonToFormData";
import InstituteService from "../../../services/InstituteService/institute.service";
import { InstituteValidationSchema } from "../instituteFormValidation";
interface InstituteFormProps {
  visible: boolean;
  closeHandler: () => void;
  data: any;
  refreshList: () => void;
}
export const InstituteForm: FC<InstituteFormProps> = ({
  visible,
  closeHandler,
  data,
  refreshList,
}) => {
  const handleSubmit = (values: any) => {
    setButtonLoading(true);
    let jsonData = serialize(Institute, values);
    if (values?.logo) jsonData["logo"] = values["logo"];
    let formData = convertJSONToFormData({ institute: jsonData });

    if (data) {
      InstituteService.updateInstitute(
        data?.id,
        formData,
        () => {
          refreshList();
          closeHandler();
        },
        () => {},
        () => {
          setButtonLoading(false);
        }
      );
    } else {
      InstituteService.createInstitute(
        formData,
        () => {
          refreshList();
          closeHandler();
        },
        () => {},
        () => {
          setButtonLoading(false);
        }
      );
    }
  };
  const formRef = useRef<any>();
  const [initialValues, setInitialValues] = useState<any>({});
  const [buttonLoading, setButtonLoading] = useState(false);
  useEffect(() => {
    setInitialValues({
      isActive: data ? data?.isActive : true,
      logo: null,
      name: data?.name,
      contactPerson: data?.contactPerson,
      registeredAddress: data?.registeredAddress,
      email: data?.email,
      phoneNumber: data?.phoneNumber,
    });
  }, [data]);

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      innerRef={formRef}
      onSubmit={() => {}}
      validationSchema={InstituteValidationSchema}
    >
      {({ values, setFieldValue, resetForm }) => (
        <UIModal
          visible={visible}
          closeModal={closeHandler}
          onClosed={() => {
            resetForm();
          }}
          submitProps={{
            text: data ? "Update" : "Create",
            clickHandler: () => {
              handleSubmit(values);
            },
            buttonLoading: buttonLoading,
          }}
          cancelProps={{
            text: "Cancel",
            clickHandler: () => {
              closeHandler();
            },
          }}
          className="institute-form__container"
        >
          <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <div className="institute-form__header">
              <div className="institute-form__title">
                {data ? "Update New Institute" : "Create New Institute"}
              </div>
              <div className="institute-form__toggle">
                <Field name="isActive" as="switch">
                  <ToggleSwitch
                    checked={values?.isActive}
                    handleChange={(checked) => {
                      setFieldValue("isActive", checked);
                    }}
                  />
                </Field>
              </div>
            </div>

            <Field name="logo" as="file-upload">
              <UploadLogo
                logoUrl={values?.logo ? values?.logo : data?.logoUrl}
                setFile={(_, file) => setFieldValue("logo", file)}
              />
            </Field>
            <div className="institute-form__input">
              <div className="institute-form__label">Institute Name</div>
              <InputField
                type="text"
                name="name"
                placeholder="Type institute name"
              />
            </div>
            <div className="institute-form__input">
              <div className="institute-form__label">Contact Person</div>
              <InputField
                type="text"
                name="contactPerson"
                placeholder="Type name"
              />
            </div>
            <div className="institute-form__input">
              <div className="institute-form__label">Email</div>
              <InputField
                type="text"
                name="email"
                placeholder="Type email address"
              />
            </div>
            <div className="institute-form__input">
              <div className="institute-form__label">Phone Number</div>
              <InputField
                type="text"
                name="phoneNumber"
                placeholder="Type number"
                prefix={"+91"}
              />
            </div>
            <div className="institute-form__input">
              <div className="institute-form__label">Registered Address</div>
              <InputField
                type="textarea"
                name="registeredAddress"
                placeholder="Type here .."
              />
            </div>
          </Form>
        </UIModal>
      )}
    </Formik>
  );
};
